export function emptySelection() {
    return { allSelected: false, selection: {} };
}
export function toggleSelection(state, itemId) {
    const current = getState(state, itemId);
    let next;
    switch (current) {
        case 'included':
            next = 'excluded';
            break;
        case 'excluded':
            next = 'included';
            break;
        default:
            next = state.allSelected ? 'excluded' : 'included';
    }
    return {
        allSelected: state.allSelected,
        selection: { ...state.selection, [itemId]: next },
    };
}
export function toggleAllSelections(state) {
    return { allSelected: !state.allSelected, selection: {} };
}
export function isSelected(state, itemId) {
    const itemState = getState(state, itemId);
    if (state.allSelected) {
        return itemState !== 'excluded';
    }
    return itemState === 'included';
}
export function countSelected(state, total) {
    if (state.allSelected) {
        return total - excludedIds(state).length;
    }
    return selectedIds(state).length;
}
export function selectedIds(state) {
    return idsWithState(state, 'included');
}
export function excludedIds(state) {
    return idsWithState(state, 'excluded');
}
function idsWithState(state, itemState) {
    return Object.keys(state.selection).filter(id => state.selection[id] === itemState);
}
function getState(state, itemId) {
    if (Object.prototype.hasOwnProperty.call(state.selection, itemId)) {
        return state.selection[itemId];
    }
    return 'unknown';
}
